import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { updateAddress, updateCompany, updateEmergencyContact } from './profile.slice';
import { tap } from 'rxjs/operators';
import { ToastSandbox } from '@app/core/sandboxes/toast.sandbox';

@Injectable()
export class ProfileEffects {
	actions$ = inject(Actions);
	toastSandbox = inject(ToastSandbox);

	updateAddressSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateAddress.load.success),
			tap(() => this.toastSandbox.showSuccessToast({ key: 'my-profile.update-address.success' }))),
		{ dispatch: false });

	updateCompanySuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateCompany.load.success),
			tap(() => this.toastSandbox.showSuccessToast({ key: 'my-profile.update-company.success' }))),
		{ dispatch: false });

	updateEmergencyContactSuccess$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateEmergencyContact.load.success),
			tap(() => this.toastSandbox.showSuccessToast({ key: 'my-profile.update-emergency-contact.success' }))),
		{ dispatch: false });
}